<template>
  <div class="serve_page" id="serve_page">
    <Header :title="title" :goBackHandler="goBack"></Header>
    <img src="https://zgjywx.oss-cn-shenzhen.aliyuncs.com/customer-service.jpg" style="width:100%" alt="customer-service-qrcode" />
</template>

<script>
import Header from "@/components/Header";

export default {
  name: "Serve",
  components: {
    Header
  },
  data() {
    return {
      title: { name: "在线客服" }
    };
  },
  methods: {
    goBack() {
      if (this.$store.state.app && this.$route.query.back == 1) {
        this.$pub.appAction("closeAppPage");
      } else {
        this.$router.go(-1);
      }
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.serve_page {
  height: 100vh;
  overflow: hidden;
  .serve_iframe {
    height: 100vh;
  }
}
</style>
